import { render } from "./RiwayatKaryawan.vue?vue&type=template&id=33866742"
import script from "./RiwayatKaryawan.vue?vue&type=script&lang=js"
export * from "./RiwayatKaryawan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__